import React from 'react'
import LtsInputText from '../../../components/lottus/lts-input-text'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import './ConfigRetornoTextField.scss'

/**
 * Componente para editar um campo de texto simples
 *
 * @param {string} props.value - Valor do campo
 * @param {Function} props.onChange - Callback chamado quando o valor é alterado
 * @param {string} props.title - Título do campo (h5)
 * @param {string} props.name - Nome do campo
 * @param {string} props.label - Label do input
 * @param {string} props.error - Mensagem de erro de validação
 * @returns {JSX.Element}
 */
export default function ConfigRetornoTextField(props) {
  const { value = '', onChange, title, name, label, error } = props

  const handleChange = (newValue) => {
    onChange?.(newValue)
  }

  return (
    <div className="config-retorno-text-field">
      <div className="card card-w-title">
        <h5>{title}</h5>

        <div className="form-group">
          <LtsInputText
            value={value}
            onChange={(e) => handleChange(e)}
            name={name}
            label={label}
            className={error ? 'p-invalid' : ''}
          />
          {error && <small className="p-error">{error}</small>}
        </div>
      </div>
    </div>
  )
}
